<template>
  <template v-if="param.componentId === 'addableTable'">
    <div v-if="property.LoadItem">
      <p v-for="(obj, i) in value" :key="i" class="tsw-p" v-html="addableTableText(obj, property.LoadItem)"></p>
    </div>
    <table v-else class="cus-addable-table">
      <tbody>
        <tr class="cus-table-head">
          <th style="width: 50px">序号</th>
          <th v-for="(column, i) in property.TableColumns" :key="i" :style="`width: ${column.Width || 'initial'}`">
            {{column.Name}}
          </th>
        </tr>
        <tr v-for="(obj, i) in value" :key="i">
          <td>
            <p>{{obj.ORDER_NUMBER}}</p>
          </td>
          <td v-for="(column, j) in property.TableColumns" :key="j">
            <p>
              {{obj[column.Key]}}         
            </p>
          </td>
        </tr>
        <tr v-if="property.Total">
          <td>
            <p>{{value.length + 1}}</p>
          </td>
          <td>
            <p>{{property.Total.Label}}</p>
          </td>
          <td :colspan="property.TableColumns.length" class="text-left">
            <p>
              {{form[property.Total.Key]}}          
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </template>
  <template v-else-if="param.componentId === 'evalScore'">
    <table class="cus-addable-table tsw-table-article">
      <colgroup>
        <col style="width: 80px">
        <col v-if="property.TableName" style="width: 130px">
        <col style="width: 130px">
        <col style="width: 130px">
        <col>      
      </colgroup>
      <tbody>
        <tr class="tsw-table-thead">
          <th v-for="(column, i) in property.TableColumns" :key="i" :colspan="column.Span || 1">
            {{column.Name}}
          </th>
        </tr>
        <template v-for="(obj, i) in value" :key="i">
          <tr v-for="(o, j) in obj.data" :key="j">
            <td v-if="property.TableName && !i && !j" :rowspan="lines">
              <p>{{property.TableName}}</p>
            </td>
            <td v-if="!j" :rowspan="obj.rows">
              <p>{{obj.EVAL_NAME}}（{{obj.CODE_TOTAL}}）</p>
            </td>
            <td>
              <p>{{o.EVAL_ITEM}}</p>
            </td>
            <td>
              <p>
                <span class="tsw-value">{{o.EVAL_NUM}}</span>
              </p>
            </td>
            <td class="text-left">
              <p>
                <span class="tsw-value">{{o.EVAL_STANDARD}}</span>
              </p>
            </td>
          </tr>
        </template>
        <tr v-if="property.TableCount">
          <td><p>小计</p></td>
          <td><p>{{count}}</p></td>
          <td></td>
        </tr>
        <tr class="tsw-table-tfoot">
          <td :colspan="property.TableName ? 5 : 4" class="text-left">
            <p v-for="(obj, i) in property.TableFoot" :key="i" class="tsw-p bold">
              {{obj}}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </template>
  <template v-else-if="param.componentId === 'addableTableV2'">
    <table class="cus-addable-table-v2 tsw-table-article">
      <colgroup>
        <col style="width: 50px">
        <col v-for="(head, i) in property.TableHeads" :key="i" :style="`width: ${head.Width || 'initial'}`" >
      </colgroup>
      <tbody>
        <tr class="cus-table-thead">
          <th v-for="(head, i) in property.TableHeads" :key="i" :colspan="i ? 1 : 2">
            {{head.Name}}
          </th>
        </tr>
        <template v-for="(obj, i) in property.TableColumns" :key="i">
          <template v-if="value">
            <tr v-for="(o, j) in value[obj.Key]" :key="j">
              <template v-if="!j">
                <td :rowspan="value[obj.Key].length" style="width: 50px; vertical-align: middle">
                  <p>{{i + 1}}</p>
                </td>
                <td :rowspan="value[obj.Key].length" style="vertical-align: middle">
                  <p>{{obj.Name}}</p>
                </td>            
              </template>
              <td v-for="(v, k) in obj.Children" :key="k" :style="{textAlign: v.Align}">
                <p>{{o[v.Key]}}</p>
              </td>
            </tr>          
          </template>
        </template>
      </tbody>
    </table>
  </template>
  <template v-else-if="param.componentId === 'evalScoreEpc'">
    <table class="tsw-table-article text-center">
      <colgroup>
        <!-- <col style="width: 50px"> -->
        <col v-for="(column, i) in property.TableColumns" :key="i" :style="`width: ${column.Width || 'initial'}`" >
      </colgroup>
      <tbody>
        <tr class="tsw-table-thead">
          <!-- <th>序号</th> -->
          <th v-for="(column, i) in property.TableColumns" :key="i">{{column.Name}}</th>
        </tr>
        <tr v-for="(obj, i) in value" :key="i">
          <!-- <td>{{ i + 1 }}</td> -->
          <td v-for="(column, i) in property.TableColumns" :key="i">
            <p class="tsw-p"><span class="span-value-text">{{ column.format ? column.format.replace('{}', obj[column.Key]) : obj[column.Key] }}</span></p>
          </td>
        </tr>
      </tbody>
    </table>
  </template>
  <template v-else-if="param.componentId === 'evalScoreJzsj'">
    <table class="cus-addable-table-v2 tsw-table-article">
      <colgroup>
        <col style="width: 150px">
        <col v-for="(head, i) in property.TableColumns" :key="i" :style="colWidth" >
      </colgroup>
      <tbody>
        <tr class="cus-table-thead">
          <th class="cus-table-index">评分内容&emsp;档次</th>
          <th v-for="(head, i) in property.TableColumns" :key="i">
            {{head.Name}}
          </th>
        </tr>
        <template v-for="(obj, i) in value" :key="i">
          <tr>
            <td>
              <p class="tsw-p bold">{{obj.CONTENT}}</p>
            </td>
            <td v-for="(column, j) in property.TableColumns" :key="j">
              <p class="tsw-p text-center">
                <span class="span-value-text">{{obj[column.Key]}}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td :colspan="1 + property.TableColumns.length">
              <p class="tsw-p text-left" style="white-space: pre-line;">
                <span class="span-value-text">{{obj.EXPLAIN}}</span>
              </p>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </template>
  <template v-else-if="param.componentId === 'evalScoreSzsj'">
    <table class="cus-addable-table-v2 tsw-table-article">
      <colgroup>
        <col style="width: 150px">
        <col v-for="(head, i) in property.TableColumns" :key="i" :style="colWidth" >
      </colgroup>
      <tbody>
        <tr class="cus-table-thead">
          <th>评分栏目</th>
          <th v-for="(head, i) in property.TableColumns" :key="i">
            {{head.Name}}
          </th>
        </tr>
        <template v-for="(obj, i) in value" :key="i">
          <tr v-for="(item, j) in obj.data" :key="100 * i + j">
            <td v-if="!j" :rowspan="obj.data.length">
              <p class="tsw-p text-left">{{obj.EVAL_NAME}}</p>
            </td>
            <td v-for="(column, k) in property.TableColumns" :key="k">
              <p class="tsw-p text-left"><span class="span-value-text">{{item[column.Key]}}</span></p>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </template>
  <template v-else-if="['checkbox'].indexOf(param.componentId) >= 0">
    <label v-for="(obj, i) in property.Options" :key="i" v-show="!obj.Hidden" class="viewer-checkbox">
      <img :src="iconForCheckbox(value, obj.Value)" alt="Checkbox">{{obj.Name}}
    </label>
  </template>
  <template v-else-if="['radio'].indexOf(param.componentId) >= 0">
    <label v-for="(obj, i) in property.Options" :key="i" class="viewer-checkbox">
      <img :src="iconForRadio(value, obj.Value)" alt="Checkbox">{{obj.Name}}
    </label>
  </template>
  <template v-else-if="param.componentId === 'uploadFile'">
    <file-list :file-list="value"></file-list>
  </template>
  <template v-else-if="param.componentId === 'latestYears'">
    近<span class="span-value-text">{{value}}</span>年（指
    <template v-for="(v, k) in form[`${propertyKey}_LIST`]" :key="k">
      <template v-if="k">，</template>
      <span class="span-value-text">{{v}}</span>年度
    </template>
    ）
  </template>
  <template v-else-if="param.componentId === 'editor'">
    <div class="span-value-html" :style="style" v-html="value"></div>
  </template>
  <template v-else>
    <span class="span-value-text" data-type="text" :style="style">{{value}}</span>
  </template>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FileList from '../../../file-list/src'
import utils from '../../../common/js/utils'
import IconCheckedPrimary from '../img/icon-checked-primary.png'
import IconUnChecked from '../img/icon-unchecked.png'
export default {
  name: 'TenderFormItem',
  components: {
    FileList
  },
  props: {
    chapterIndex: {
      type: Number,
      default: 0
    },
    sectionIndex: {
      type: Number,
      default: 0
    },
    propertyKey: {
      type: String,
      default: ''
    },
    attrs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      count: 0,
      lines: 0,
      fontSize: 16
    }
  },
  computed: {
    ...mapState(['form', 'isTemplate']),
    ...mapGetters(['chapters', 'properties']),
    colWidth() {
      const { TableColumns } = this.property
      if (TableColumns) return `width: ${700 / TableColumns.length}px`
      return ''
    },
    sectionKey() {
      let {chapterIndex, sectionIndex} = this
      return `/${chapterIndex}/section-0${sectionIndex+1}`.replace(/0(\d{2})/, '$1')
    },
    property() {
      let {properties, sectionKey, propertyKey} = this
      
      return properties[sectionKey][propertyKey]
    },
    param() {
      let {property} = this
      if(property) {
        return utils.buildUrlParam(property.Type)
      } else {
        return {}
      }
    },
    value() {
      let {form, property, param} = this
      let value = form[property.Key]
      if(param.componentId === 'addableTable') {
        return this.loadFilterAddableTableData(value || [], property.TableColumns)
      } else if(['evalScore'].indexOf(param.componentId) >= 0) {
        return this.loadFilterEvalScore(value || [])
      } else if(['addableTableV2'].indexOf(param.componentId) >= 0) {
        return value
      } else if(['select'].indexOf(param.componentId) >= 0) {
        if(value instanceof Array) {
          return value.join(',')
        } else if(param.trueValue) {
          return form['select_' + property.Key] || ''
        } else if (param.showName) {
          return property.Options[value] ? property.Options[value].Name : ''
        } else {
          return value || ''
        }
      } else if(param.componentId === 'radio') {
        if(param.trueValue) {
          return [form['select_' + property.Key] || '']
        } else {
          return [value || '']
        }
      } else if(param.componentId === 'checkbox') {
        return value
      } else if(['date', 'datetime'].indexOf(param.componentId) >= 0) {
        return this.dateText(value, param.format, param.isString)
      } else if(['uploadFile'].indexOf(param.componentId) >= 0) {
        return value || []
      } else {
        return value || ''
      }
    },
    textLength() {
      if(typeof this.value === 'string') {
        return this.value.replace(/[\u0391-\uFFE5]/g, '--').length / 2
      } else {
        return this.value.length
      }
    },
    minWidth() {
      const { fontSize } = this
      const { minWidth } = this.attrs
      const width = minWidth ? minWidth.replace(/\D/g, '') - 5 : 90
      return width / fontSize
    },
    style() {
      let {textLength, attrs, minWidth} = this
      if (attrs.minWidth) {
        return {
          minWidth: `${attrs.minWidth}`,
          display: textLength > minWidth ? 'inline' : 'inline-block'
        }
      } else {
        return {}
      }
    }
  },
  created() {
    let {propertyKey, form, property, param} = this
    if(param.componentId === 'select') {
      if(param.trueValue) {
        let xxx = property.Options.find(obj => obj.Value === param.trueValue === form[propertyKey])
        form[`select_${propertyKey}`] = xxx ? xxx.Value : ''
      }
      if(param.EnumKey) {
        let EnumValue = form[param.EnumKey]
        let xxx = property.Options.find(obj => obj.EnumValue === EnumValue)
        form[property.Key] = xxx ? xxx.Value : ''
      }
    }
  },
  mounted() {
    const { dataset = {} } = this.$el
    if (dataset.type === 'text') {
      this.fontSize = getComputedStyle(this.$el).fontSize.replace(/\D/g, '')
    }
  },
  methods: {
    addableTableText(obj, pattern) {
      return pattern.replace(/\{([\w\_]+)\}/g, (...x) => obj[x[1]])
    },
    dateText(date, format, isString) {
      // console.log('dateText', date, format, isString)
      if(date) {
        if (isString) return utils.DateFormat(format, new Date(date))
        return utils.DateFormat(format, new Date(date.$date))
      } else {
        return ''
      }
    },
    loadFilterAddableTableData(list, columns) {
      list = utils.copy(list)
      columns.forEach(col => {
        if(['date', 'datetime'].indexOf(col.Type) >= 0) {
          list.forEach(obj => {
            obj[col.Key] = this.dateText(obj[col.Key], col.Format)
          })
        }
      })
      return list
    },
    loadFilterEvalScore(list, columns) {
      let { TableCount } = this.property
      let xxxx = TableCount ? 1 : 0
      list = utils.copy(list)
      list.forEach((obj, i) => {
        obj.rows = obj.data.length + xxxx
      })
      this.count = list.reduce((pre, cur) => pre + cur.CODE_TOTAL, 0) || 0
      this.lines = list.reduce((pre, cur) => pre + cur.data.length, 0)
      return list
    },
    iconForCheckbox(values, value) {
      if(values && values.indexOf(value) >= 0) {
        return IconCheckedPrimary
      } else {
        return IconUnChecked
      }
    },
    iconForRadio(values, value) {
      if(values && values.indexOf(value) >= 0) {
        return IconCheckedPrimary
      } else {
        return IconUnChecked
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$valueColor: #2393e4;
.span-value-text {
  text-indent: 0;
  word-break: break-all;
  line-height: 1;
  padding: 5px 5px;
  width: auto;
  min-width: 100px;
  cursor: text;
  text-align: left;
  outline: none;
  color: $valueColor;
  border-bottom: 1px solid black;
  &:before{
    content: '';
    display: inline-block;
  }
}
.span-value-html {
  color: #2196F3;
}
.cus-addable-table {
  .cus-table-thead {
    background: #EEF1F6;
  }
  td {
    color: $valueColor;
  }
  .text-left {
    text-align: left;
  }
}
.cus-table-index {
  position: relative;
  &:before {
    content: "";
    width: 1px;
    height: 30px;
    display: block;
    position: absolute;
    top: -2px;
    left: 90px;
    border-right: 1px solid #000000;
    transform: rotate(152deg);
  }
}
</style>
<style lang="scss">
.viewer-checkbox {
  margin-right: 30px;
  display: inline-block;
  img {
    vertical-align: text-bottom;
    margin-right: 5px;
  }
  .el-checkbox__input.is-disabled .el-checkbox__inner {
    color: black;
    background: white;
    border-color: black;
    cursor: initial;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    &, &::after {
      border-color: black;
    }
  }
  .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: black;
  }
}
</style>